import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IState {
    ckycNumber?: string
    ckycStatus?: string
    identityNumber?: string
    identityType?: string
    documentType?: string
    documentValue?: string
    document?:File|null
    ckycHash?: string
    insurerExtraData?: any
}


const initialState: IState = {
    ckycNumber: '',
    ckycStatus: '',
    identityNumber: '',
    identityType: '',
    documentType: '',
    documentValue: '',
    document:null,
    ckycHash: '',
    insurerExtraData: null
}

const ckycSlice = createSlice({
    name: 'ckyc',
    initialState: initialState,
    reducers: {
        resetCkyc: () => initialState,
        updateCkycDetails: (state, action: PayloadAction<IState>) => {
            const { ckycHash, ckycNumber, ckycStatus, documentType, documentValue, identityNumber, identityType, insurerExtraData } = action.payload
            if (ckycHash) state.ckycHash = ckycHash
            if (ckycNumber) state.ckycNumber = ckycNumber
            if (ckycStatus) state.ckycStatus = ckycStatus
            if (documentType) state.documentType = documentType
            if (documentValue) state.documentValue = documentValue
            if (identityNumber) state.identityNumber = identityNumber
            if (identityType) state.identityType = identityType
            if (insurerExtraData) state.insurerExtraData = insurerExtraData
        }
    }
})

const { reducer } = ckycSlice

const { resetCkyc, updateCkycDetails } = ckycSlice.actions

export { 
    reducer as ckycReducer,
    resetCkyc,
    updateCkycDetails
}
